import { useTranslation } from '../../../utils/useTranslation';
import { IconClock } from '../../icon/IconClock';
import { IconFillClose } from '../../icon/IconFillClose';
import { Flex } from '../../layout/Flex';
import { Typography, TypographyVariant } from '../../typography/Typography';
import { CollectionStatus, CollectionUI } from '../../users/types';

export const getStatus = (collectionModel: CollectionUI, variant?: TypographyVariant) => {
    const t = useTranslation();

    if (collectionModel.status === CollectionStatus.MODERATION) {
        return (
            <Flex direction="row" alignItems="center" spacing={0.5}>
                <IconClock size={14} color="var(--color-primary)" />
                <Typography variant={variant || 'body'}>{t('На модерации')}</Typography>
            </Flex>
        );
    }

    if (collectionModel.status === CollectionStatus.DECLINED) {
        return (
            <Flex direction="row" alignItems="center" spacing={0.5}>
                <IconFillClose size={14} color="var(--color-primary)" />
                <Typography variant={variant || 'body'}>{t('Отклонена')}</Typography>
            </Flex>
        );
    }

    if (
        !collectionModel.status ||
        collectionModel.status === CollectionStatus.PUBLISHED ||
        collectionModel.status === CollectionStatus.LIMITED
    ) {
        return (
            <Typography variant={variant || 'body'}>
                {collectionModel.isPublic ? t('Публичная коллекция') : t('Секретная коллекция')}
            </Typography>
        );
    }
};
